import { FilterV2 } from "PFTypes/filters_v2";

import { FiltersV2Data } from "./filters_v2_store.types";

type FilterUpdateEventPayload = {
  previousFilters: FilterV2[];
  updatedFilters: FilterV2[];
  updatedState: FiltersV2Data;
};

export enum FilterV2Event {
  FiltersUpdate = "filtersUpdate",
  FiltersMetaSynced = "filtersMetaSynced"
}

export type FiltersV2EventHandlers = {
  [FilterV2Event.FiltersUpdate]: (payload: FilterUpdateEventPayload) => void;
  [FilterV2Event.FiltersMetaSynced]: (payload: FiltersV2Data) => void;
};
